import { Route, Routes } from 'react-router-dom';
import './App.css';
import Layout from './components/shared/Layout';
import { Home } from './components/shared/Home';
import SignoutOidc from './providers/Signout-oidc';
import SigninOidc from './providers/Signin-oidc';
import AuthGuard from './store/AuthGuard';
import { CountryList } from './pages/admin/Countries/CountryList';
import { UpdateCountry } from './pages/admin/Countries/UpdateCountry';
import { ViewCountry } from './pages/admin/Countries/ViewCountry';
import { AddCountry } from './pages/admin/Countries/AddCountry';
import { AddWorkHour } from './pages/admin/WorkHours/AddWorkHour';
import { WorkHourList } from './pages/admin/WorkHours/WorkHourList';
import { UpdateWorkHour } from './pages/admin/WorkHours/UpdateWorkHour';
import { ViewWorkHour } from './pages/admin/WorkHours/ViewWorkHour';
import CreateJobCategory from './pages/admin/JobCategories/AddJobCategory';
import { JobCategoryList } from './pages/admin/JobCategories/JobCategoryList';
import UpdateJobCategory from './pages/admin/JobCategories/UpdateJobCategory';
import ViewJobCategory from './pages/admin/JobCategories/ViewJobCategory';
import { JobSubCategoryList } from './pages/admin/JobSubCategories/JobSubCategoryList';
import { AddJobSubCategory } from './pages/admin/JobSubCategories/AddJobSubCategory';
import { UpdateJobSubCategory } from './pages/admin/JobSubCategories/UpdateJobSubCategory';
import { ViewJobSubCategory } from './pages/admin/JobSubCategories/ViewJobSubCategory';
import { PublicHolidayList } from './pages/admin/PublicHolidays/PublicHolidayList';
import { Content } from './pages/admin/Content/Content';
import { ViewPublicHoliday } from './pages/admin/PublicHolidays/ViewPublicHoliday';
import { Employers } from './pages/members/Employers/Employers';
import { AddEmployer } from './pages/members/Employers/AddEmployer';
import { Diary } from './pages/members/Diary/Diary';
import { UserLandingPage } from './components/shared/landingpages/UserLandingPage';
import { WorkActivity } from './pages/members/WorkActivities/WorkActivities';
import { UnAuthorised } from './components/shared/unauthorised/UnAuthorised';
import { Authserverconstants } from './utils/AuthServerConstants';
import { TermsAndConditionsPage } from './components/shared/landingpages/TermsAndConditionsPage';
import { Help } from './pages/members/Help/Help';
import { Feedback } from './pages/members/Feedback/Feedback';
import { Report } from './pages/members/Reports/Index';
import { WorkHourDetailList } from './pages/admin/WorkHours/WorkHourDetails/WorkHourDetailList';
import { AddWorkHourDetails } from './pages/admin/WorkHours/WorkHourDetails/AddWorkHourDetails';
import { UpdateWorkHourDetails } from './pages/admin/WorkHours/WorkHourDetails/UpdateWorkHourDetails';
import { ViewWorkHourDetails } from './pages/admin/WorkHours/WorkHourDetails/ViewWorkHourDetails';
import { Faqs } from './pages/members/Help/Faqs';
import { RateLimiting } from './components/shared/RateLimiting/RateLimiting';

function App() {
    return (
        <Layout>
            <Routes>
                <Route path="/" element={<Home />}></Route>
                <Route path="/signout-oidc" element={<SignoutOidc />} />
                <Route path="/signin-oidc" element={<SigninOidc />} />
                <Route path="/unauthorised" element={<UnAuthorised />} />
                <Route path="/ratelimiting" element={<RateLimiting />} />
                <Route path="/termsandcondition" element={<TermsAndConditionsPage />}></Route>

                <Route element={<AuthGuard allowedRoles={Authserverconstants.Members_Features_Url} />}>
                    <Route path="/userlandingpage" element={<UserLandingPage />}></Route>
                    <Route path="/workActivity" element={<WorkActivity />}></Route>
                    <Route path="/employerlist" element={<Employers />}></Route>
                    <Route path="/addemployers" element={<AddEmployer />}></Route>
                    <Route path="/diary" element={<Diary />}></Route>
                    <Route path="/feedback" element={<Feedback />}></Route>
                    <Route path="/help" element={<Help />}></Route>
                    <Route path="/reports" element={<Report />}></Route>
                    <Route path="/faqs" element={<Faqs />}></Route>
                </Route>

                <Route element={<AuthGuard allowedRoles={Authserverconstants.Admin_Features_Url} />}>
                    <Route path="/content" element={<Content />}></Route>

                    <Route path="/country" element={<CountryList />}></Route>
                    <Route path="/addcountry" element={<AddCountry />}></Route>
                    <Route path="/editcountry/:id" element={<UpdateCountry />}></Route>
                    <Route path="/viewcountry/:id" element={<ViewCountry />}></Route>

                    <Route path="/publicholidaylist" element={<PublicHolidayList />}></Route>
                    <Route path="/viewpublicholiday/:id" element={<ViewPublicHoliday />}></Route>

                    <Route path="/addWorkHour" element={<AddWorkHour />}></Route>
                    <Route path="/workhour" element={<WorkHourList />}></Route>
                    <Route path="/updateWorkHour/:id" element={<UpdateWorkHour />}></Route>
                    <Route path="/viewWorkHour/:id" element={<ViewWorkHour />}></Route>

                    <Route path="/workhourDetails/:id" element={<WorkHourDetailList />}></Route>
                    <Route path="/addworkhourDetails/:id" element={<AddWorkHourDetails />}></Route>
                    <Route path="/viewWorkhourDetails/:id" element={<ViewWorkHourDetails />}></Route>
                    <Route path="/updateWorkhourDetails/:id" element={<UpdateWorkHourDetails />}></Route>

                    <Route path="/createjobcategory" element={<CreateJobCategory />}></Route>
                    <Route path="/jobcategory" element={<JobCategoryList />}></Route>
                    <Route path="/updatejobcategory/:id" element={<UpdateJobCategory />}></Route>
                    <Route path="/viewjobcategory/:id" element={<ViewJobCategory />}></Route>

                    <Route path="/jobsubcategory/:id" element={<JobSubCategoryList />}></Route>
                    <Route path="/addjobsubcategory/:id" element={<AddJobSubCategory />}></Route>
                    <Route path="/editjobsubcategory/:id" element={<UpdateJobSubCategory />}></Route>
                    <Route path="/viewjobsubcategory/:id" element={<ViewJobSubCategory />}></Route>
                </Route>
            </Routes>
        </Layout>
    )
}

export default App;